import { render, staticRenderFns } from "./ImageCaptionSlice.vue?vue&type=template&id=3dbe9854&scoped=true&"
import script from "./ImageCaptionSlice.vue?vue&type=script&lang=js&"
export * from "./ImageCaptionSlice.vue?vue&type=script&lang=js&"
import style0 from "./ImageCaptionSlice.vue?vue&type=style&index=0&id=3dbe9854&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dbe9854",
  null
  
)

export default component.exports